// import Vue from 'vue';
// const drag = Vue.directive('drag',{
//   bind:function(el,parms){
//   },
//   inserted:function(el,x){
//     // 拖拽范围参数
//     let parms = x.value
//     if(!parms){
//       parms = {
//         width:document.body.offsetWidth,
//         height:document.body.offsetHeight
//       }
//     }
//     el.onmousedown = function (e) {
//       el.getElementsByTagName("div")[0].setAttribute('flag', false)
//       const firstTime = new Date().getTime()
//       let widthNum = parms.width - el.offsetWidth
//       let heightNum = parms.height - el.offsetHeight
//       var disx = e.pageX - el.offsetLeft;
//       var disy = e.pageY - el.offsetTop;
//       document.onmousemove = function (e) {
//         let wStr = e.pageX - disx
//         let hStr = e.pageY - disy
//         if(wStr>0){
//           el.style.left = (wStr-widthNum>0)?widthNum:wStr + 'px';
//         }else{
//           el.style.left = 0
//         }
//         if(hStr>0){
//           el.style.top = (hStr-heightNum>0)?heightNum:hStr + 'px';
//         }else{
//           el.style.top = 0
//         }
//         return false
//       }
//       document.onmouseup = function () {
//         const lastTime = new Date().getTime()
//         if ((lastTime - firstTime) < 400) {
//           el.getElementsByTagName("div")[0].setAttribute('flag', true)
//         }
//         document.onmousemove = document.onmouseup = null;
//       }
//     }
//   },
//   updated:function(el) {}
// })
// export default drag;

import Vue from 'vue';

const drag = Vue.directive('drag', {
  inserted: function (el, binding, vnode) {
    // 拖拽范围参数
    let parms = binding.value;
    if (!parms) {
      parms = {
        width: Math.max(document.body.offsetWidth, window.innerWidth),
        height: Math.max(document.body.offsetHeight, window.innerHeight)
      };
    }

    let isDragging = false;
    let startX, startY, initialX, initialY;
    let firstTime = null
    const handleDown = (e) => {
      // e.preventDefault();
      el.setAttribute('flag', false)
      firstTime = new Date().getTime()
      isDragging = true;
      const event = e.type === 'touchstart' ? e.touches[0] : e;
      startX = event.clientX;
      startY = event.clientY;
      initialX = el.offsetLeft;
      initialY = el.offsetTop;
    };
    const handleMove = (e) => {
      if (!isDragging || el.getAttribute('drag') == "no") return;
      // e.preventDefault();
      const event = e.type === 'touchmove' ? e.touches[0] : e;
      const currentX = event.clientX;
      const currentY = event.clientY;
      const diffX = currentX - startX;
      const diffY = currentY - startY;

      let newLeft = initialX + diffX;
      let newTop = initialY + diffY;

      const widthNum = parms.width - el.offsetWidth;
      const heightNum = parms.height - el.offsetHeight;

      if (newLeft < 0) {
        newLeft = 0;
      } else if (newLeft > widthNum) {
        newLeft = widthNum;
      }

      if (newTop < 0) {
        newTop = 0;
      } else if (newTop > heightNum) {
        newTop = heightNum;
      }

      el.style.left = `${newLeft}px`;
      el.style.top = `${newTop}px`;
      vnode.context.XYchange && vnode.context.XYchange({ x: newLeft, y: newTop })
    };

    const handleUp = () => {
      isDragging = false
      const lastTime = new Date().getTime()
      if ((lastTime - firstTime) < 200) {
        el.setAttribute('flag', true)
      }
    };

    el.addEventListener('mousedown', handleDown);
    el.addEventListener('mousemove', handleMove);
    el.addEventListener('mouseup', handleUp);

    el.addEventListener('touchstart', handleDown);
    el.addEventListener('touchmove', handleMove);
    el.addEventListener('touchend', handleUp);

    // 清理事件监听器
    el.addEventListener('hook:beforeDestroy', () => {
      el.removeEventListener('mousedown', handleDown);
      el.removeEventListener('mousemove', handleMove);
      el.removeEventListener('mouseup', handleUp);

      el.removeEventListener('touchstart', handleDown);
      el.removeEventListener('touchmove', handleMove);
      el.removeEventListener('touchend', handleUp);
    });
  }
});

export default drag;



// WEBPACK FOOTER //
// ./src/public/drag.js